import React from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { VesselMap } from '@/components/map/VesselMap';
import { VesselDrawer } from '@/components/vessel/VesselDrawer';
import { GeofenceModal } from '@/components/geofence/GeofenceModal';
import { useApp } from '@/context/AppContext';

export default function DashboardPage() {
  const { selectGeofence } = useApp();

  const handleGeofenceClick = (geofence) => {
    selectGeofence(geofence);
  };

  return (
    <DashboardLayout title="Dashboard - Map View" fullWidth>
      <div className="relative w-full h-full">
        <VesselMap 
          showGeofences={true}
          showStations={false}
          onGeofenceClick={handleGeofenceClick}
        />
      </div>
      
      {/* Drawers and Modals */}
      <VesselDrawer />
      <GeofenceModal />
    </DashboardLayout>
  );
}
